"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_4_0_0 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
/**
 * Migrate to 4.0.0
 *
 * Leitung.beschriftung has been refactored to a string-enum.
 *
 *  export enum BeschriftungTypes {
 *    NONE = 0,
 *    FOILLABEL = 1,
 *    SHRINKTUBE = 2
 * }
 *
 *  =>
 *
 *  export enum LeitungBeschriftung {
 *    keine = 'Keine',
 *    folienlabel = 'Folienlabel',
 *    schrumpfschlauch = 'Schrumpfschlauch'
 *  }
 */
const migration_4_0_0 = (json) => {
    if (json.Leitungen) {
        json.Leitungen = json.Leitungen.map((l) => {
            if (l.Beschriftung === '0' || l.Beschriftung === 0) {
                l.Beschriftung = echain_shared_articles_1.LeitungBeschriftung.keine;
            }
            else if (l.Beschriftung === '1' || l.Beschriftung === 1) {
                l.Beschriftung = echain_shared_articles_1.LeitungBeschriftung.folienlabel;
            }
            else if (l.Beschriftung === '2' || l.Beschriftung === 2) {
                l.Beschriftung = 'Schrumpfschlauch';
            }
            return l;
        });
    }
    return json;
};
exports.migration_4_0_0 = migration_4_0_0;
//# sourceMappingURL=migration_4_0_0.js.map